(function () {
  angular.module("akitabox.mobile.directives.pinValueList", [
    "akitabox.core.pinValue",
    "akitabox.core.services.asset",
    "akitabox.core.services.pinValue",
    "akitabox.core.services.room",
    "angular.filter",
  ]);
})();
